export default __webpack_public_path__ + "static/media/multicolumns.ee53f213.png";